import React from "react";

function QuizPopup({ setOpenQuizPopup }) {
    return (
        <div className="ContainerSubmitedSucess2 ">
            <div className="SubContainerSubmitedSucess innerContainerFlex">
                <div className="imageContainer">
                    <img src="/images/wip_blog.gif" alt="" />
                </div>
                <div className="rightContainer">
                    <div className="studentLogos leftMargin">
                        <div></div>
                        <div>
                            <img
                                src="/StudentImg/BreathSchoolLogo.png"
                                alt="icon"
                                width={"30px"}
                            ></img>
                        </div>
                    </div>
                    <div className=" overallMarginHead mt-5" style={{ color: "red" }}>
                        <h2 className="">Stay tuned, the feature will be available soon! ^_^</h2>
                    </div>
                    <div className="" style={{ display: "flex", justifyContent: "center", marginLeft: "70%", marginTop: "13%", background: "none" }}>
                        <button
                            style={{ background: "none", padding: "8px 17px", borderRadius: "8px", border: "2px solid #F77F00" }}
                            onClick={() => setOpenQuizPopup(false)}
                        >
                            Okay
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default QuizPopup;
